var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270_538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6518 20.4676L20.4747 5.10511C20.7897 4.3902 20.1033 3.65022 19.3668 3.91077L3.53602 9.5627C2.933 9.77186 2.7542 10.5295 3.18171 10.9903L5.95105 13.9887C6.25212 14.3133 6.7512 14.3696 7.11188 14.1075L17.4217 6.82615L9.38192 16.5546C9.09952 16.9011 9.11827 17.403 9.41934 17.7275L12.2017 20.7139C12.6292 21.1747 13.3981 21.0532 13.6518 20.4676Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270_538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.73714f27728bb31924c14716f60bcac3.svg";
export { ForwardRef as ReactComponent };